import { Route, Routes } from "react-router-dom";
import { DataProvider } from "~/src/contexts/AppDataContext/DataProvider";
import StorageProvider from "~/src/contexts/StorageContext/StorageProvider";
import Velkommen from "../Velkommen/Velkommen";
import MainLayout from "./Layout";

const RequireDataLayout = () => {
  return (
    <StorageProvider>
      <DataProvider>
        <Routes>
          <Route path="/velkommen" element={<Velkommen />} />
          <Route path="/*" element={<MainLayout />} />
        </Routes>
      </DataProvider>
    </StorageProvider>
  );
};

export default RequireDataLayout;
